import React from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation, useParams } from "react-router-dom";

import Layout from "../../components/Layout";
import InfoFooter from "../../components/InfoFooter";
import PhotoGrid from "../../components/PhotoGrid";
import useAlbums from "../../hooks/useAlbums";

const PhotoAlbum = () => {
  const { albumTitle } = useParams();
  const location = useLocation();
  const passedAlbum = location.state?.album;

  // Only hit /albums when the album was not handed over by the gallery,
  // i.e. on a direct link or a reload.
  const { albums, loading } = useAlbums();
  const album =
    passedAlbum ||
    albums.find((item) => item.name === decodeURIComponent(albumTitle));

  if (!album) {
    if (loading) {
      return (
        <Layout>
          <div className="loader-container">
            <div className="loader" />
          </div>
        </Layout>
      );
    }

    return (
      <Layout>
        <Helmet title="Album nenalezeno | Optika Volyně" />
        <div className="article-error">
          <h1>Album se nepodařilo najít</h1>
          <Link className="btn" to="/galerie">
            Zpět do galerie
          </Link>
        </div>
        <InfoFooter />
      </Layout>
    );
  }

  return (
    <Layout>
      <Helmet
        title={`${album.name} | Optika Volyně`}
        meta={[
          {
            name: "description",
            content: `Fotogalerie ${album.name} - Optika Volyně`,
          },
        ]}
      />
      <main>
        <PhotoGrid album={album} />
      </main>
      <InfoFooter />
    </Layout>
  );
};

export default PhotoAlbum;
